<template>
  <div
    id="headernav"
    class="navbar"
    :class="{ 'hidden-navbar': !showNavbar, 'menu-is-open': menuOpen, 'is-scrolled': isScrolled }"
  >
    <GridContainer class="bg">
      <nav class="">
        <div class="nav-left">
          <span
            class="glow animate delay-1 wordmark"
            style="
              display: flex;
              flex-direction: row;
              gap: var(--spacing-xs);
              align-items: center;
              text-decoration: none !important;
            "
          >
            <!-- <router-link to="/" class="nav-avatar-link" aria-label="View resume">
              <img
                class="nav-avatar"
                src="@/assets/images/portrait.jpg"
                draggable="false"
                alt="Jacques Ramphal"
              />
              <img
                class="nav-avatar"
                src="@/assets/images/avatar/avatar.svg"
                draggable="false"
                alt="Jacques Ramphal"
              />
            </router-link> -->

            <BreadCrumb :isDesktopScreen="isDesktopScreen" @toggle-menu="toggleFullscreenMenu" />
          </span>
        </div>

        <ul class="links justify-end glow">
          <!-- Writing stays in the bar on desktop; on phones the menu carries it -->
          <li v-if="isDesktopScreen" class="glow animate delay-2">
            <TextLink label="Library" route="/library" />
          </li>

          <li class="glow animate delay-2">
            <!-- Desktop: a text link. Phones: two bars that cross into an x
                 when the menu is open; the label moves to aria-label. -->
            <button
              type="button"
              class="menu-toggle"
              :class="{ 'menu-toggle--icon': !isDesktopScreen, 'is-open': menuOpen }"
              :aria-label="isDesktopScreen ? undefined : menuOpen ? 'Close menu' : 'Open menu'"
              :aria-expanded="menuOpen ? 'true' : 'false'"
              aria-haspopup="dialog"
              @click="toggleMenu && toggleMenu()"
            >
              <template v-if="isDesktopScreen">{{ menuOpen ? 'Close' : 'Menu' }}</template>
              <span v-else class="menu-icon" aria-hidden="true"><span></span><span></span></span>
            </button>
          </li>
        </ul>
      </nav>
    </GridContainer>
  </div>
</template>

<script>
import GridContainer from '../grid/GridContainer.vue';
import BreadCrumb from '../BreadCrumb.vue';
import TextLink from '../text/TextLink.vue';

const OFFSET = 60;
export default {
  name: 'HeaderNav',
  components: { GridContainer, BreadCrumb, TextLink },
  props: {
    breadcrumb: {
      type: Boolean,
      default: false,
    },
    hasHeadings: {
      type: Boolean,
      default: false,
    },
    headings: {
      type: Array,
      default: () => [],
    },
    activeHeading: {
      type: String,
      default: null,
    },
    menuOpen: {
      type: Boolean,
      default: false,
    },
    toggleMenu: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      backgroundColor: '#ffffff', // Not in use - Replace with your hex color
      showNavbar: true,
      lastScrollPosition: 0,
      scrollValue: 0,
      isScrolled: false,
      isMobileScreen: false,
      isDesktopScreen: false,
    };
  },
  computed: {
    isMarkdownPage() {
      return this.$route?.path?.startsWith('/doc/');
    },
    // not in use - start
    backgroundStyle() {
      const rgb = this.hexToRgb(this.backgroundColor);
      return {
        background: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.95)`,
      };
    },
  },
  // not in use - end
  mounted() {
    this.lastScrollPosition = window.pageYOffset;
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onWindowResize);
    const viewportMeta = document.createElement('meta');
    viewportMeta.name = 'viewport';
    viewportMeta.content = 'width=device-width, initial-scale=1';
    document.head.appendChild(viewportMeta);

    this.onWindowResize();
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onWindowResize);
  },

  methods: {
    // not in use - start

    hexToRgb(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : null;
    },
    // not in use - end

    onScroll() {
      // Keep navbar visible when menu is open
      if (this.menuOpen) {
        this.showNavbar = true;
        return;
      }
      if (window.pageYOffset <= 0) {
        this.isScrolled = false;
        return;
      }
      this.isScrolled = true;
      if (Math.abs(window.pageYOffset - this.lastScrollPosition) < OFFSET) {
        return;
      }
      this.showNavbar = window.pageYOffset < this.lastScrollPosition;
      this.lastScrollPosition = window.pageYOffset;
    },
    onWindowResize() {
      this.showNavbar = true; // Ensure the navbar is always visible when resizing
      this.isMobileScreen = window.innerWidth < 768;
      this.isDesktopScreen = window.innerWidth >= 768;
    },
    setFont(font) {
      this.selectedFont = font;
      this.$emit('update:font', font);
    },
  },
  watch: {
    $route() {
      // Ensure navbar is visible when route changes
      this.showNavbar = true;
      this.onWindowResize(); // Re-check screen size
    },
  },
};
</script>
<style lang="scss">
/* Unscoped so it reaches the breadcrumb's links and separators, which live in
   child components. Every piece of the header nav reads --nav-fontSize. */
.navbar nav a,
.navbar nav .breadcrumb-sep {
  font-size: var(--nav-fontSize);
}

.selected {
  font-weight: var(--fontWeight-normal);
  text-decoration: underline;
}
.nav-link > a {
  &:hover {
    background: var(--background-darker-reversed);
    transition: all 0.25s ease;
  }
}
</style>

<style lang="scss" scoped>
* {
  margin: 0;
}
/* A button that reads as one of the nav links: same face, size and underline */
.menu-toggle {
  appearance: none;
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  font-size: var(--nav-fontSize);
  font-weight: var(--fontWeight-medium);
  color: var(--foreground);
  cursor: pointer;
  text-decoration: underline; /* underlined at rest, like the nav links */
  text-underline-offset: var(--link-underline-offset);
  text-decoration-thickness: var(--link-underline-thickness);
}
.menu-toggle:hover {
  text-decoration: underline wavy var(--accent-line);
  text-decoration-thickness: var(--link-underline-thickness-hover);
}

/* Phones: the icon. Sized in em off --font-600, the size it was drawn at,
   rather than --nav-fontSize, which dropped to the reading size around it;
   the button keeps a 44px tap target. Bars are the site's line weight
   (--line-width), the same as every border, and the icon's box is snapped to
   whole pixels so the bars land on the same grid as the borders. */
.menu-toggle--icon {
  font-size: var(--font-600);
  --reading-fontWeight: var(--font-600-weight);
  font-weight: var(--font-600-weight);
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  min-inline-size: 44px;
  min-block-size: 44px;
  text-decoration: none;
}
.menu-icon {
  --bar: var(--line-width); /* the site's line weight, so the bars match the nav rule */
  position: relative;
  display: block;
  inline-size: round(1.1em, 1px);
  block-size: round(0.45em, 2px);

  /* Each bar is a top border on an empty box, not a filled box, so it snaps
     to the screen's pixels exactly as the site's borders do. */
  span {
    position: absolute;
    inset-inline: 0;
    block-size: 0;
    border-block-start: var(--bar) solid currentColor;
    transition:
      transform 0.25s ease,
      top 0.25s ease;
  }
  span:first-child {
    top: 0;
  }
  /* Floored to a whole pixel: at calc(100% - 1.5px) the bar sat half a pixel
     off the top bar's grid and drew visibly thinner. */
  span:last-child {
    top: calc(100% - var(--bar)); /* browsers without round() */
    top: round(down, calc(100% - var(--bar)), 1px);
  }
}
.menu-toggle--icon.is-open .menu-icon span {
  top: calc(50% - var(--bar) / 2);
}
.menu-toggle--icon.is-open .menu-icon span:first-child {
  transform: rotate(45deg);
}
.menu-toggle--icon.is-open .menu-icon span:last-child {
  transform: rotate(-45deg);
}
@media (prefers-reduced-motion: reduce) {
  .menu-icon span {
    transition: none;
  }
}
@media print {
  * {
    display: none;
  }
}
// .blur {
//   block-size: 100% ;
//   inline-size: 100vw;
//   position: absolute;
//   z-index: -1;
//   filter: blur(20px); /* Blur amount on hover, can be adjusted */
// }

// TESTING MIX BLEND MODE!!!!

// html {
//   background: #fff;
// }

// .blend {
//   mix-blend-mode: exclusion;
//   color: white;
//   display: block;
//   height: 100%;
//   width: 100%;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   text-align: center;
//   font-size: 6vw;
// }
button {
  border: 0 !important;
}
:active {
  outline: transparent;
}

.navbar {
  display: flex;
  inset-block-start: 0;
  align-items: center;
  overflow: visible;
  position: fixed !important;
  transform: translate3d(0, 0, 0) !important;
  transition: 0.4s transform cubic-bezier(0.68, -0.55, 0.27, 1.55) !important;
  inline-size: 100vw !important;
  z-index: 100000 !important;
  @media only screen and (min-width: 768px) {
    inset-block-start: 0;
    // mix-blend-mode: difference;
  }
}
/* The bar's background: the page colour at full strength, reaching above the
   bar to cover the bounce */
.navbar::after {
  content: '';
  position: absolute;
  inset-block-start: -100%;
  inset-block-end: 0;
  inset-inline-end: 0;
  inline-size: 100%;
  background: var(--background); /* the page colour at full opacity, so nothing shows through */
  z-index: -1;
  @media only screen and (min-width: 768px) {
    // background: transparent;
    inset-block-end: 0;
    inset-block-start: -100%;
  }
}
.navbar.hidden-navbar {
  transform: translate3d(0, -150%, 0) !important;
  @media only screen and (min-width: 768px) {
    transform: translate3d(0, -150%, 0) !important;
  }
}
/* Keep navbar visible when menu is open */
.navbar.menu-is-open {
  transform: translate3d(0, 0, 0) !important;
}
/* The bar is the plain page colour (the ::after above), with no rule and no
   blur. It hides as you scroll down and comes back on the way up, so it is
   only over the text when you've asked for it. */

.bg {
  background: var(--background);
  transition: 0.5s box-shadow ease-in-out !important;
  justify-self: flex-end;
  overflow: visible;
  position: relative;
  padding-block: var(--spacing-xs) !important;
  // The links end where the content does.
  padding-inline-end: var(--spacing-sm) !important;

  inline-size: 100%;
  // border-block-start: var(--spacing-xxs) solid var(--color-yellow);

  border-block-end: none;
  @media only screen and (min-width: 768px) {
    background: transparent;

    // padding-block: var(--size-12) var(--spacing-sm) !important;
    // padding-inline: var(--spacing-lg) !important;
    // padding-inline-end: var(--spacing-md) !important;
    // border-block-end: var(--border);
    border-block-end: none;
    justify-self: end;
  }
  @media only screen and (min-width: 1024px) {
    // padding-inline: var(--spacing-xl) !important;
  }
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-self: flex-end;
  gap: var(--spacing-sm);
  @media only screen and (min-width: 768px) {
    gap: var(--spacing-md);
    a,
    router-link {
      // mix-blend-mode: difference !important;
    }
  }
}
li {
  list-style: none;
  float: left;
  font-size: var(--nav-fontSize);
  line-height: 1;
  margin: 0;
  text-decoration: none;
  &:first-child {
    padding-inline-end: 0;
  }
}
nav {
  overflow: visible;
  align-items: center;
  display: grid;
  grid-template-columns: 1fr auto;
  /* Phones: the breadcrumb's fade already separates it from the menu icon,
     and the icon's 44px target has slack on its left, so a smaller gap. */
  gap: var(--spacing-sm);
  @media only screen and (min-width: 768px) {
    gap: var(--spacing-md);
  }
  // block-size: 5.2rem;
  justify-self: stretch;
  position: relative;
  /* Phones: the menu icon's and breadcrumb's 44px tap targets overhang the
     bar by 10px top and bottom instead of setting its height, so the bar
     sizes to a 24px row and matches the sticky section bar (56px). */
  @media only screen and (max-width: 767px) {
    margin-block: -10px;
  }
}

.nav-left {
  /* Lets the column shrink below the breadcrumb's width, so a long trail
     scrolls inside it instead of pushing the menu off the screen. */
  min-inline-size: 0;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
  align-items: flex-start;
  @media only screen and (min-width: 768px) {
    a,
    router-link {
      // mix-blend-mode: difference !important;
    }
  }
}

.nav-avatar-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none !important;
}

::v-deep(.nav-wordmark-link) {
  text-decoration: none !important;
  color: inherit !important;

  &:link,
  &:visited,
  &:hover,
  &:active,
  &:focus {
    text-decoration: none !important;
    color: inherit !important;
  }
}

// Alternative deep selector syntax for different Vue versions
:deep(.nav-wordmark-link) {
  text-decoration: none !important;
  color: inherit !important;

  &:link,
  &:visited,
  &:hover,
  &:active,
  &:focus {
    text-decoration: none !important;
    color: inherit !important;
  }
}

.nav-avatar {
  inline-size: var(--spacing-md);
  block-size: var(--spacing-md);
  aspect-ratio: 1 / 1;
  border-radius: 100%;
  object-fit: cover;
  box-shadow: var(--shadow-light);
}

#richlink {
  text-decoration: none !important;
}

.router-link-exact-active {
  text-decoration: underline dashed !important;
}
p {
  margin: 0;
}

.wordmark {
  color: var(--foreground);
  max-inline-size: 100%;
  min-inline-size: 0;

  #richlink,
  a,
  router-link {
    text-decoration: none !important;
    color: inherit !important;

    &:link,
    &:visited,
    &:hover,
    &:active,
    &:focus {
      text-decoration: none !important;
      color: inherit !important;
    }
  }

  // Override router-link-exact-active for wordmark. Decoration only — colour is
  // left to the link itself so the breadcrumb's current-page crumb can own its
  // own colour instead of being pinned to whatever .wordmark inherits.
  .router-link-exact-active,
  :deep(.router-link-exact-active) {
    text-decoration: none !important;
  }
}

// mix-blend-mode: difference requires white content for correct inversion.
// White on white bg → black (readable). White on dark bg → white (readable).
// Must use :deep() to pierce Vue scoped boundary into BreadCrumb/TextLink,
// and !important to beat the global `color: var(--foreground) !important` in typography.scss.
@media only screen and (min-width: 768px) {
  :deep(a),
  :deep(router-link),
  :deep(.nav-wordmark-link),
  :deep(.nav-item),
  :deep(p),
  :deep(span) {
    // color: red !important;
  }

  // Blend-mode underline overrides — disabled with the blend mode itself.
  // :deep(.button--textlink) {
  //   text-decoration-color: white !important;
  // }
  // :deep(a:hover),
  // :deep(router-link:hover),
  // :deep(.button--textlink:hover) {
  //   text-decoration-color: white !important;
  // }
}
// .wordmark::after {
//   @media only screen and (min-width: 768px) {
//     content: "/";
//     padding: var(--spacing-xxs);
//     opacity: 0.5;
//     font-weight: var(--fontWeight-normal);
//   }
// }
</style>
